import { HomePage } from "@/features/home/pages/HomePage";
import { PrivacyBanner } from "@/shared/components/PrivacyBanner/PrivacyBanner";
import { LocaleProvider, type Locale } from "@/shared/i18n/LocaleContext";

export function App({ initialLocale }: Readonly<{ initialLocale?: Locale }>) {
  return (
    <LocaleProvider initialLocale={initialLocale}>
      <HomePage />
      <PrivacyBanner />
    </LocaleProvider>
  );
}
